/* What order the cards come off the printer in. */
import { PRINT_ORDER } from './layout.js';
import { printable } from './model.js';

/* Within a category the stack runs by pillar, alphabetically, then by company
   and name inside each pillar so one organisation's badges stay together.

   The pillar is compared lower-cased because the ticketing data holds both
   "Sinar Mas Land" and "Sinar Mas land"; sorted as written they would become
   two separate blocks in the stack with 64 badges in one and 235 in the other.

   A blank pillar sorts last rather than first: it is the odd case, and it
   belongs at the end of the pile, not at the top of it. */
const key = a => {
  const pillar = (a.pillar || '').trim().toLowerCase();
  return `${pillar ? '0' + pillar : '1'}|${a.company.toLowerCase()}`
       + `|${a.name.toLowerCase()}|${a.ticket}`;
};
const bySort = (x, y) => key(x).localeCompare(key(y));

/** Group by category in print order; family cards ride behind their parent. */
export function orderAttendees(list, familyMode = 'with_parent') {
  const pool = list.filter(printable).map(a => ({ ...a, printGroup: a.category }));
  const byTicket = new Map(pool.map(a => [a.ticket, a]));

  const children = new Map();
  const attached = new Set();
  if (familyMode === 'with_parent') {
    for (const a of pool) {
      const parent = byTicket.get(a.parent);
      if (a.category === 'family' && parent && parent !== a) {
        if (!children.has(a.parent)) children.set(a.parent, []);
        children.get(a.parent).push(a);
        attached.add(a.ticket);
        a.printGroup = parent.category;
      }
    }
    for (const kids of children.values()) kids.sort(bySort);
  }

  const out = [];
  for (const slug of PRINT_ORDER) {
    const block = pool.filter(a => a.category === slug && !attached.has(a.ticket));
    if (slug === 'family' && familyMode !== 'with_parent') {
      block.sort((x, y) =>
        (x.parent || '').localeCompare(y.parent || '') || bySort(x, y));
    } else {
      block.sort(bySort);
    }
    for (const a of block) {
      out.push(a);
      for (const kid of children.get(a.ticket) || []) out.push(kid);
    }
  }
  return out;
}

export function groupByCategory(ordered) {
  const groups = new Map();
  for (const a of ordered) {
    const g = a.printGroup || a.category;
    if (!groups.has(g)) groups.set(g, []);
    groups.get(g).push(a);
  }
  return groups;
}
